import requests from "./httpService";

const CityServices = {

  addCity: async (body) => {
    return requests.post("/city/add", body);
  },
  getAllCity: async (body) => {
    return requests.get("/city/", body);
  },
  getPeriodicHourlyCity: async (body) =>{
    return requests.get("/place/getCities/hourlyRental")
  },
  getPeriodicDailyCity: async (body) =>{
    return requests.get("/place/getCities/outstation")
  },
  getCityById: async (id, body) => {
    return requests.get(`/city/${id}`, body);
  },
  getCityByStateId:async (id,body) => {
    return requests.get(`/city/cityByState/${id}`, body);
  },

  updateCity: async (id, body) => {
    return requests.put(`/city/update/${id}`, body);
  },

  deleteCity: async (id) => {
    return requests.delete(`/city/delete/${id}`);
  },
 
};

export default CityServices;
